module.exports = __webpack_public_path__ + "img/help_search2.d8640f51.png";